// src/components/TermDetailModal.js
import React from 'react';

const TermDetailModal = ({ term, onClose }) => {
  if (!term) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ease-in-out"
      onClick={onClose} // Overlay click closes modal
    >
      <div
        className="bg-white p-6 md:p-8 rounded-lg shadow-xl max-w-2xl w-full max-h-[85vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()} // Prevent modal close when clicking inside content
      >
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700">{term.term}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-3xl leading-none font-semibold"
            aria-label="閉じる"
          >
            &times; {/* HTML entity for '×' (multiplication sign) */}
          </button>
        </div>
        <span className="inline-block bg-blue-100 text-blue-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded mb-3">
          カテゴリ: {term.category}
        </span>
        <p className="text-gray-700 leading-relaxed mb-4 whitespace-pre-line">
          {term.description}
        </p>
        {term.relatedTerms && term.relatedTerms.length > 0 && (
          <div className="mt-4 pt-4 border-t border-gray-200">
            <h4 className="text-md font-semibold text-gray-800 mb-2">関連用語:</h4>
            <ul className="list-disc list-inside">
              {term.relatedTerms.map((related, index) => (
                <li key={index} className="text-gray-600 text-sm mb-1">{related}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default TermDetailModal;